import { combineEpics } from "redux-observable";

import getClientProfileEntriesEpic$ from "./getClientProfileEntriesEpic";
import getClientProfileEntriesCountEpic$ from "./getClientProfileEntriesCountEpic";
import getClientProfileEntryDetailsEpic$ from "./getClientProfileEntryDetailsEpic";
import changeClientProfileEntryStatusEpic$ from "./changeClientProfileEntryStatusEpic";
import exportClientProfilePdfEpic$ from "./exportClientProfilePdfEpic";

export default combineEpics(
  getClientProfileEntriesEpic$,
  getClientProfileEntriesCountEpic$,
  getClientProfileEntryDetailsEpic$,
  changeClientProfileEntryStatusEpic$,
  exportClientProfilePdfEpic$
);



// WEBPACK FOOTER //
// ./src/features/client-profile/epics/index.js